
<template>
  <div>
    <a href="javascript:void(0)" class="text-dark text-decoration-none d-flex justify-content-center text-center" data-bs-toggle="modal" data-bs-target="#groupModal">
      Group Insurance
    </a>
    <div id="groupModal"
      class="modal-title modal"
      tabindex="-1"
      aria-labelledby="groupModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-4">
            <h4 class="text-center">Group Insurance</h4>
            <div>
          <!-- These are dynamic in strong, comes from SF  -->
          <p class="fw-bold">We are delighted to extend a <strong>10%</strong> discount to any of our Group Travel clients provided a minimum of 10 clients are 
            insured under the same policy. For more details and to book, please contact our specialist Group Travel Department 
            on <strong>020 7408 9005</strong>  or visit us at <strong>215 Kensington High Street, London W8 6BD</strong>
          </p>
        </div>
        <div class="text-center">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
        </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      modalShow:false,
    }
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  }
}
</script>
<style scoped>
</style>